import { createContext, useContext, type ReactNode } from 'react';
import type { IntakeApi } from './client';
import { createDevFakeApi } from './fake';
import { createHttpApi } from './http';

/**
 * `VITE_API_MODE=http` talks to /claim/api/v1; anything else uses the stateful fake (the
 * default), persisted to localStorage. The mode is replaced at build time, so an `http`
 * build carries no fake.
 */
export function apiFromEnv(): IntakeApi {
  if (import.meta.env.VITE_API_MODE === 'http') return createHttpApi();
  return createDevFakeApi();
}

const ApiContext = createContext<IntakeApi | null>(null);

export function ApiProvider({ api, children }: { api: IntakeApi; children: ReactNode }) {
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useApi(): IntakeApi {
  const api = useContext(ApiContext);
  if (!api) throw new Error('useApi() outside <ApiProvider>');
  return api;
}
